
import React from 'react';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { useTranslation } from 'react-i18next';

interface QuestionFieldsProps {
  register: any;
  errors: any;
}

const QuestionFields: React.FC<QuestionFieldsProps> = ({ register, errors }) => {
  const { t } = useTranslation();
  
  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="question">{t('interview.question')}</Label>
        <Textarea
          id="question"
          placeholder={t('form.placeholders.question')}
          {...register('question', { required: t('form.validation.required') })}
          className={errors.question ? 'border-red-500' : ''}
          rows={3}
        />
        {errors.question && (
          <p className="text-red-500 text-sm">{errors.question.message}</p>
        )}
      </div>

      <div className="space-y-2">
        <Label htmlFor="context">{t('interview.context')} ({t('form.optional')})</Label>
        <Textarea
          id="context"
          placeholder={t('form.placeholders.context')}
          {...register('context')}
          rows={3}
        />
      </div>
    </>
  );
};

export default QuestionFields;
